import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

import { SessionService } from "./../_shared/session/session.service";
import { ProcessoService } from "./../_shared/processo/processo.service";
import { ContatoService } from "../_shared/contato/contato.service";
import { Contato } from "../_shared/contato/contato";

@Component({
  selector: "app-mensagem-final",
  templateUrl: "./mensagem-final.component.html",
  styleUrls: ["./mensagem-final.component.css"],
})
export class MensagemFinalComponent implements OnInit {
  hasDocuments = false;

  public inscricaoFinalizada = false;
  public data_finalizacao: any = "0000-00-00";

  public processo;
  public linkFichaInscricao: string;
  public mensagemConcluinte;
  protected contato: Contato;

  constructor(
    private router: Router,
    private SessionService: SessionService,
    private ProcessoService: ProcessoService,
    private contatoService: ContatoService
  ) {
    this.mensagemConcluinte = sessionStorage.getItem("textoConcluinte");
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {

      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      window.scrollTo(0, 0);
    });

    this.contatoService.getContatoInfo().subscribe(
      (contato: Contato) => {
        this.contato = contato;
      },
      (error) => {
        console.error('Erro ao obter informações de contato:', error);
      }
    );

    if (this.SessionService.getValor("data_final")) {
      this.data_finalizacao = this.SessionService.getValor("data_final");
    }

    this.processo = this.ProcessoService.getProcessoSeletivoSelecionado();
    this.data_finalizacao = this.processo.PrcDatFin;

    this.verificaSession();

    this.ProcessoService.fichaInscricao().subscribe(
      (ficha) => {
        if (ficha) {
          this.linkFichaInscricao = ficha.linkFichaInscricao;
          this.ProcessoService.enviaEmail().subscribe(
            (result) => this.SessionService.clear(),
            (err) => {
              this.SessionService.clear();
              return err;
            }
          );
        }
        this.SessionService.clear();
      },
      (err) => {
        this.SessionService.clear();
        return err;
      }
    );
  }

  verificaSession() {
    const processo: number = this.ProcessoService.getTipoProcesso();

    if (this.SessionService.getValor("final") === "false") {
      this.inscricaoFinalizada = false;
    } else {
      // this.inscricaoFinalizada = processo !== 6 ? true : false;
      this.inscricaoFinalizada = true;
    }

    this.hasDocuments =
      this.SessionService.getValor("temDocumentos") === "true";
  }
}



// WEBPACK FOOTER //
// ./src/app/mensagem-final/mensagem-final.component.ts